import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TelefonePipe } from '@shared/pipes/telefone.pipe';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AutoCompleteModule, BreadcrumbModule, ButtonModule, CalendarModule, CardModule, ChartModule, CheckboxModule, DropdownModule, MessagesModule, MultiSelectModule, PaginatorModule, RadioButtonModule, TabViewModule, TreeModule } from 'primeng';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CardComponent } from './card/card.component';
import { AlertCustomComponent } from './components/alert-custom/alert-custom.component';
import { AutocompleteChipComponent } from './components/autocomplete-chip/autocomplete-chip.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { CardMenuComponent } from './components/card-menu/card-menu.component';
import { CardsQuantitativosAvaliacaoDesempenhoComponent } from './components/cards-quantitativos-avaliacao-desempenho/cards-quantitativos-avaliacao-desempenho.component';
import { CardsQuantitativosComponent } from './components/cards-quantitativos/cards-quantitativos.component';
import { DatePickerRangeComponent } from './components/date-picker-range/date-picker-range.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DragAndDropComponent } from './components/drag-and-drop/drag-and-drop.component';
import { EditableFieldComponent } from './components/editable-field/editable-field.component';
import { FieldComponent } from './components/field/field.component';
import { FileAttachmentComponent } from './components/file-attachment-component/file-attachment.component';
import { FilterComponent } from './components/filter/filter.component';
import { AdvancedPieChartComponent } from './components/generic-charts/advanced-pie-chart/advanced-pie-chart.component';
import { FooterStackedChartComponent } from './components/generic-charts/footer-stacked-char/footer-stacked-chart.component';
import { NormalizedHorizontalBarChartComponent } from './components/generic-charts/normalized-horizontal-bar-chart/normalized-horizontal-bar-chart.component';
import { PieChartComponent } from './components/generic-charts/pie-chart/pie-chart.component';
import { CustomBarChartLineaStatusComponent } from './components/generic-charts/vertical-custom-bar/custom-bar-chart-linea-status/custom-bar-chart-linea-status.component';
import { VerticalCustomBarComponent } from './components/generic-charts/vertical-custom-bar/vertical-custom-bar.component';
import { GenericFormComponent } from './components/generics-crud-components/generic-form/generic-form.component';
import { CustomActionsDirective } from './components/generics-crud-components/generic-list/directives/custom-actions.directive';
import { CustomColumnsDirective } from './components/generics-crud-components/generic-list/directives/custom-columns.directive';
import { GenericListComponent } from './components/generics-crud-components/generic-list/generic-list.component';
import { LoadingCustomInterceptor } from './components/loading-custom/config/loading-custom-interceptor';
import { LoadingCustomComponent } from './components/loading-custom/loading-custom.component';
import { ModalAvisoPadraoComponent } from './components/modal-aviso-padrao/modal-aviso-padrao.component';
import { ModalCustomComponent } from './components/modal-custom/modal-custom.component';
import { ModalJustificativaComponent } from './components/modal-justificativa/modal-justificativa.component';
import { ModalRedigiteSenhaIncorretaComponent } from './components/modal-redigite-senha/modal-redigite-senha-incorreta/modal-redigite-senha-incorreta.component';
import { ModalRedigiteSenhaComponent } from './components/modal-redigite-senha/modal-redigite-senha.component';
import { ModalRelatoriosComponent } from './components/modal-relatorios/modal-relatorios.component';
import { ModalUploadSingleFileComponent } from './components/modal-upload-single-file/modal-upload-single-file.component';
import { PageTitleCustomComponent } from './components/page-title-custom/page-title-custom.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { PaginatorCustomDinamicComponent } from './components/paginator-custom-dinamic/paginator-custom-dinamic.component';
import { PaginatorCustomComponent } from './components/paginator-custom/paginator-custom.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { TableBodyDirective } from './components/table-custom/config/table-body.directive';
import { TableEmptyDirective } from './components/table-custom/config/table-empty.directive';
import { TableFooterDirective } from './components/table-custom/config/table-footer.directive';
import { TableHeaderDirective } from './components/table-custom/config/table-header.directive';
import { TableCustomComponent } from './components/table-custom/table-custom.component';
import { TimelineHorizontalComponent } from './components/timeline-horizontal/timeline-horizontal.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { TreeSelectionComponent } from './components/tree-selection/tree-selection.component';
import { UploadLargeFileComponent } from './components/upload-large-file/upload-large-file.component';
import { UploadManyFilesComponent } from './components/upload-many-files/upload-many-files.component';
import { UploadOneFileV2Component } from './components/upload-one-file-v2/upload-one-file-v2.component';
import { UploadOneFileComponent } from './components/upload-one-file/upload-one-file.component';
import { UploadPhotoComponent } from './components/upload-photo/upload-photo.component';
import { VerticalStackedBarComponent } from './components/vertical-stacked-bar/vertical-stacked-bar.component';
import { ApenasAlfaNumericoDirective } from './directives/apenas-alfanumerico.directive';
import { EmailDirective } from './directives/email.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { OnlyTextDirective } from './directives/only-text.directive';
import { RemoverMultiplosEspacosDirective } from './directives/remover-multiplos-espacos.directive';
import { TelefoneDirective } from './directives/telefone.directive';
import { UpperCaseDirective } from './directives/upper-case.directive';
import { WhiteTooltipDirective } from './directives/white-tooltip.directive';
import { HorizontalBarStackedComponent } from './generic-charts/horizontal-bar-stacked/horizontal-bar-stacked.component';
import { CPFPipe } from './pipes/cpf.pipe';
import { StatusPipe } from './pipes/status.pipe';
import { TrueFalsePipe } from './pipes/true-false.pipe';


@NgModule({
  declarations: [
    AlertCustomComponent,
    LoadingCustomComponent,
    PaginatorCustomComponent,
    TableCustomComponent,
    TableHeaderDirective,
    TableBodyDirective,
    TableFooterDirective,
    TableEmptyDirective,
    UpperCaseDirective,
    OnlyNumberDirective,
    OnlyTextDirective,
    CardComponent,
    UploadOneFileComponent,
    PageTitleComponent,
    SearchInputComponent,
    FilterComponent,
    ToggleSwitchComponent,
    StatusPipe,
    AutocompleteComponent,
    DatePickerComponent,
    UploadPhotoComponent,
    CPFPipe,
    FieldComponent,
    DragAndDropComponent,
    GenericListComponent,
    GenericFormComponent,
    CustomColumnsDirective,
    PieChartComponent,
    AdvancedPieChartComponent,
    FooterStackedChartComponent,
    NormalizedHorizontalBarChartComponent,
    UploadLargeFileComponent,
    CardMenuComponent,
    QuestionnaireComponent,
    CardsQuantitativosComponent,
    TimelineHorizontalComponent,
    ProgressBarComponent,
    ModalAvisoPadraoComponent,
    PageTitleCustomComponent,
    ModalRedigiteSenhaComponent,
    ModalRedigiteSenhaIncorretaComponent,
    UploadOneFileV2Component,
    RadioButtonComponent,
    ModalUploadSingleFileComponent,
    ModalJustificativaComponent,
    DatePickerRangeComponent,
    RadioButtonComponent,
    TrueFalsePipe,
    TreeSelectionComponent,
    PaginatorCustomDinamicComponent,
    FileAttachmentComponent,
    ModalRelatoriosComponent,
    VerticalCustomBarComponent,
    CustomBarChartLineaStatusComponent,
    CustomActionsDirective,
    VerticalStackedBarComponent,
    HorizontalBarStackedComponent,
    TelefonePipe,
    EditableFieldComponent,
    TelefoneDirective,
    RemoverMultiplosEspacosDirective,
    ApenasAlfaNumericoDirective,
    EmailDirective,
    UploadManyFilesComponent,
    WhiteTooltipDirective,
    CardsQuantitativosAvaliacaoDesempenhoComponent,
    AutocompleteChipComponent,
    ModalCustomComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    BreadcrumbModule,
    NgxMaskModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circleSwish,
      backdropBorderRadius: '0px',
      fullScreenBackdrop: true,
      backdropBackgroundColour: 'rgba(0,0,0,0.3)',
      primaryColour: '#007bff',
      secondaryColour: '#0069d9',
      tertiaryColour: '#007bff'
    }),
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AutoCompleteModule,
    NgxChartsModule,
    DragDropModule,
    CalendarModule,
    TabViewModule,
    PaginatorModule,
    TreeModule,
    MessagesModule,
    ToastModule,
    ButtonModule,
    CardModule,
    ChartModule,
    NgxChartsModule,
    NgxPermissionsModule.forChild()
  ],
  exports: [
    AlertCustomComponent,
    LoadingCustomComponent,
    PaginatorCustomComponent,
    TableCustomComponent,
    TableHeaderDirective,
    TableBodyDirective,
    TableFooterDirective,
    TableEmptyDirective,
    UpperCaseDirective,
    OnlyNumberDirective,
    OnlyTextDirective,
    CardComponent,
    UploadOneFileComponent,
    PageTitleComponent,
    SearchInputComponent,
    FilterComponent,
    MultiSelectModule,
    ToggleSwitchComponent,
    CheckboxModule,
    StatusPipe,
    AutocompleteComponent,
    DatePickerComponent,
    UploadPhotoComponent,
    DatePickerComponent,
    RadioButtonModule,
    DragAndDropComponent,
    CPFPipe,
    FieldComponent,
    GenericListComponent,
    GenericFormComponent,
    CustomColumnsDirective,
    PieChartComponent,
    AdvancedPieChartComponent,
    FooterStackedChartComponent,
    NormalizedHorizontalBarChartComponent,
    UploadLargeFileComponent,
    CardMenuComponent,
    QuestionnaireComponent,
    CardsQuantitativosComponent,
    TimelineHorizontalComponent,
    ProgressBarComponent,
    PageTitleCustomComponent,
    UploadOneFileV2Component,
    TrueFalsePipe,
    DropdownModule,
    RadioButtonComponent,
    ModalUploadSingleFileComponent,
    ModalJustificativaComponent,
    DatePickerRangeComponent,
    RadioButtonComponent,
    TreeSelectionComponent,
    FileAttachmentComponent,
    PaginatorCustomDinamicComponent,
    ModalRelatoriosComponent,
    VerticalCustomBarComponent,
    CustomBarChartLineaStatusComponent,
    CustomActionsDirective,
    ButtonModule,
    TabViewModule,
    ToastModule,
    CardModule,
    ChartModule,
    NgxChartsModule,
    VerticalStackedBarComponent,
    HorizontalBarStackedComponent,
    TelefonePipe,
    EditableFieldComponent,
    TelefoneDirective,
    RemoverMultiplosEspacosDirective,
    ApenasAlfaNumericoDirective,
    EmailDirective,
    UploadManyFilesComponent,
    WhiteTooltipDirective,
    CardsQuantitativosAvaliacaoDesempenhoComponent,
    AutocompleteChipComponent,
    ModalCustomComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingCustomInterceptor,
      multi: true
    },
    MessageService
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
